import { calculateTotalStableCoins } from '../components/stableswap/TokenReserves';
import { TokenMetadata } from '../services/ft-contract';
import { toReadableNumber, percent } from './numbers';
import {
  STABLE_LP_TOKEN_DECIMALS,
  RATED_POOL_LP_TOKEN_DECIMALS,
} from '../components/stableswap/AddLiquidity';
import {
  toInternationalCurrencySystem,
  toPrecision,
  scientificNotationToString,
} from './numbers';
import { getCurrentWallet } from './wallets-integration';
import { PoolData } from '../state/stablePoolData';
import { isStablePool, isRatedPool } from '../services/near';

export const getStablePoolDecimal = (id: string | number) => {
  if (isRatedPool(id)) return RATED_POOL_LP_TOKEN_DECIMALS;
  else if (isStablePool(id)) return STABLE_LP_TOKEN_DECIMALS;
};

export function formatPoolData({
  pool,
  userTotalShare,
  farmStake,
  tokens,
  shares,
  poolTVL,
}: PoolData) {
  const isSignedIn = getCurrentWallet()?.wallet?.isSignedIn();

  const tokensMap: {
    [id: string]: TokenMetadata;
  } = tokens.reduce((pre, token) => ({ ...pre, [token.id]: token }), {});

  const { coinsAmounts } = calculateTotalStableCoins([pool], tokensMap);

  const parsedUsertotalShare = scientificNotationToString(
    userTotalShare.toString()
  );

  const displayTVL =
    poolTVL === undefined
      ? '-'
      : `$${toInternationalCurrencySystem(poolTVL?.toString() || '0', 2)}`;

  const TVLTitle =
    poolTVL === undefined ? '-' : `${toPrecision(poolTVL.toString(), 2)}`;

  const displayMyShareAmount = isSignedIn
    ? toPrecision(
        toReadableNumber(getStablePoolDecimal(pool.id), parsedUsertotalShare),
        2,
        true
      )
    : '-';

  const sharePercentValue = scientificNotationToString(
    percent(parsedUsertotalShare, pool.shareSupply).toString()
  );

  const sharePercent =
    Number(sharePercentValue) > 0 && Number(sharePercentValue) < 0.01
      ? '< 0.01%'
      : `${toPrecision(sharePercentValue, 2)}%`;

  const displaySharePercent = isSignedIn ? sharePercent : '';

  return {
    displayTVL,
    coinsAmounts,
    displayMyShareAmount,
    displaySharePercent,
    shares,
    TVLTitle,
    pool,
  };
}

export const getStableSwapTabKey = (id: string | number) =>
  `REF_STABLE_SWAP_TAB_VALUE_${id}`;
